import React, { Component } from 'react'
import './Root.css'
import './Root-mobile.css'
import { Route } from 'react-router-dom'
import SignUpMembers from './SignUpMembers'
import SignInMembers from './SignInMembers'
import Parrain from './Parrain'
import HomeMembers from './HomeMembers'
import Souscripteur from './Souscripteur'
import Beneficiaire from './Beneficiaire'
import Devis from './Devis'
import Declaration from './Declaration'
import Submitted from './Submitted'
import UserType from "./UserType"
import Entreprise from './Entreprise'
import Questionnaire from  './Questionnaire'
import Reglages from './Reglages'
import ReglagesUserData from './ReglagesUserData'
import ReglagesUserPassword from './ReglagesUserPassword'
import ValidationSouscripteur from './ValidationSouscripteur'
import Simulation from './Simulation'
import ParentCode from './ParentCode'
import LostPassword from './LostPassword'
import LostPasswordConfirm from './LostPasswordConfirm'
import DataProtection from './DataProtection'
import SignInCourtiers from './SignInCourtiers'

class Root extends Component {

  render() {
    return (
      <div>
        <Route exact path='/' render={(props) => (
          <HomeMembers {...props}/>
        )}/>
        <Route exact path='/souscripteur' render={(props) => (
          <Souscripteur {...props}/>
        )}/>
        <Route exact path='/beneficiaire' render={(props) => (
          <Beneficiaire {...props}/>
        )}/>
        <Route  exact path='/questionnaire' render={(props) => (
          <Questionnaire {...props} />
        )}/>
        <Route exact path='/devis' render={(props) => (
          <Devis {...props}/>
        )}/>
        <Route exact path='/declaration' render={(props) => (
          <Declaration {...props}/>
        )}/>
        <Route exact path='/inscription' render={() => (
          <SignUpMembers />
        )}/>
        <Route exact path='/pr/:userCode' render={(props) => (
          <ParentCode {...props}/>
        )}/>
        <Route exact path='/ip/:courtierCode' render={(props) => (
          <ParentCode {...props}/>
        )}/>
        <Route exact path='/i/devis/:devisCourtierCode' render={(props) => (
          <ParentCode {...props}/>
        )}/>
        <Route exact path='/connexion' render={(props) => (
          <SignInMembers {...props}/>
        )}/>
        <Route exact path='/connexion-intermediaires' render={(props) => (
          <SignInCourtiers {...props}/>
        )}/>
        <Route strict path='/connexion/:userID/:tokenAccess' render={(props) => (
          <SignInMembers {...props}/>
        )}/>
        <Route strict path='/connexion-apres-confirmation-mot-de-passe/:confirmLostPassword' render={(props) => (
          <SignInMembers {...props}/>
        )}/>
        <Route exact path='/parrain' render={(props) => (
          <Parrain {...props} />
        )}/>
        <Route exact path='/entreprise' render={(props) => (
          <Entreprise {...props} />
        )}/>
        <Route exact path='/user-type' render={(props) => (
          <UserType {...props} />
        )}/>
        <Route exact path='/soumis' render={(props) => (
          <Submitted {...props} />
        )}/>
        <Route exact path='/reglages' render={(props) => (
          <Reglages {...props} />
        )}/>
        <Route exact path='/reglages-user-data' render={(props) => (
          <ReglagesUserData {...props} />
        )}/>
        <Route exact path='/reglages-user-password' render={(props) => (
          <ReglagesUserPassword {...props} />
        )}/>
        <Route exact path='/validation-souscription' render={(props) => (
          <ValidationSouscripteur {...props} />
        )}/>
        <Route exact path='/simulation' render={(props) => (
          <Simulation {...props} />
        )}/>
        <Route exact path='/mot-de-passe-oublier' render={(props) => (
          <LostPassword {...props} />
        )}/>
        <Route exact path='/confirmer-mot-de-passe-oublier/:userID/:tokenAccess' render={(props) => (
          <LostPasswordConfirm {...props} />
        )}/>
        <Route exact path='/data-protection' render={(props) => (
          <DataProtection {...props} />
        )}/>
      </div>
    )
  }
}

export default Root



// WEBPACK FOOTER //
// ./src/containers/Root.js